import React from 'react'
import EstimationManagement from './abstract/EstimationManagement'
import PageHeader from '../../components/PageHeader'

class EstimationCopy extends EstimationManagement {
  onPageMenuClicked (name) {
    const {params} = this.props.match
    const fromId = params.fromId
    switch (name) {
      case 'back':
        this.props.history.push('/company_user/estimation/' + this.estimationType + '/detail/' + fromId)
        break
      case 'real':
        this.props.history.push('/company_user/estimation/' + this.estimationType + '/copy/' + fromId + '/real')
        break
      case 'template':
        this.props.history.push('/company_user/estimation/' + this.estimationType + '/copy/' + fromId + '/template')
        break
      default:
        break
    }
  }
  render () {
    const currentEstimationType = this.estimationType
    const estimationTypeCaption = this.isTemplate ? '雛型' : '見積書'
    const otherEstimationTypeCaption = this.isTemplate ? '見積書' : '雛型'
    const otherEstimationType = this.isTemplate ? 'real' : 'template'
    return (
      <div>
        <PageHeader title={estimationTypeCaption + 'のコピーまたは' + otherEstimationTypeCaption + 'の作成'} sub={'こちらから' + estimationTypeCaption + 'のコピーまたは' + otherEstimationTypeCaption + 'の作成ができます。'} history={this.props.history}>
          <ul className='nav nav-pills kw-page-actions'>
            <li className='kw-btn-area'>
              <button onClick={(e) => this.onPageMenuClicked('back')} rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary'>
                <i className='icon-arrow-left icon-large' /><span>戻る</span>
              </button>
            </li>
          </ul>
        </PageHeader>
        <section className='page container'>
          <div className='box kw-create-area'>
            <div className='box-header'>
              <i className='icon-share' />
              <h5>{estimationTypeCaption}のコピーまたは{otherEstimationTypeCaption}の作成</h5>
            </div>
            <div className='box-content'>
              <p>こちらでは、{estimationTypeCaption}をコピーして以下の作業ができます。</p>
              <div className='visible-phone text-center'>
                <button className='btn' onClick={(e) => this.onPageMenuClicked(currentEstimationType)}><i className='icon-list-alt' /> {estimationTypeCaption}を新規作成</button><br /><br />
                <button className='btn' onClick={(e) => this.onPageMenuClicked(otherEstimationType)}><i className='icon-hdd' /> {otherEstimationTypeCaption}を新規作成</button>
              </div>
              <table className='hidden-phone kw-create-tbl'>
                <tbody>
                  <tr>
                    <th><button className='btn' onClick={(e) => this.onPageMenuClicked(currentEstimationType)}><i className='icon-list-alt' /> {estimationTypeCaption}を新規作成</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-create-msg'>この{estimationTypeCaption}をコピーして、新しい{estimationTypeCaption}を作成できます。</div></td>
                  </tr>
                  <tr>
                    <th><button className='btn' onClick={(e) => this.onPageMenuClicked(otherEstimationType)}><i className='icon-hdd' /> {otherEstimationTypeCaption}を新規作成</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-create-msg'>この{estimationTypeCaption}をコピーして、{otherEstimationTypeCaption}を新規に作成できます。</div></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default EstimationCopy



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EstimationCopy.js